"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _slateReact = require("slate-react");

var _slate = require("slate");

var _IconButton = require("../IconButton/IconButton");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var isMarkActive = function isMarkActive(editor, format) {
  var marks = _slate.Editor.marks(editor);

  return marks ? marks[format] === true : false;
};

var toggleMark = function toggleMark(editor, format) {
  var isActive = isMarkActive(editor, format);

  if (isActive) {
    _slate.Editor.removeMark(editor, format);
  } else {
    _slate.Editor.addMark(editor, format, true);
  }
};

var MarkButton = function MarkButton(_ref) {
  var format = _ref.format,
      icon = _ref.icon;
  var editor = (0, _slateReact.useSlate)();
  return /*#__PURE__*/_react["default"].createElement(_IconButton.CircleButton, {
    size: 30,
    type: "button",
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggleMark(editor, format);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: icon,
    size: 20,
    activeColor: "dark.0",
    active: isMarkActive(editor, format)
  }));
};

var _default = MarkButton;
exports["default"] = _default;